<script setup>
const props = defineProps({
  icon: {
    type: String,
    required: false,
    default: 'tabler-x',
  },
  iconSize: {
    type: String,
    required: false,
    default: '20',
  },
  variant: {
    type: String,
    required: false,
    default: 'elevated',
  },
})
</script>

<template>
  <IconBtn
    :variant="props.variant"
    class="v-dialog-close-btn"
  >
    <VIcon
      :icon="props.icon"
      :size="props.iconSize"
    />
  </IconBtn>
</template>
